//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
//  -- Constants ----------------------
import { ActionTypes } from 'store/constants';
import { map, filter } from "lodash"
//  ----------------------------------------------------------------------------
//  Reducers
//  ----------------------------------------------------------------------------
//  -- Example ------------------------
const whatsNewInitial = [];
export const whats_new = (state = whatsNewInitial, action) => {
    switch (action.type) {
        case ActionTypes.whats_new.create_whats_new:
            return [action.payload, ...state];
        case ActionTypes.whats_new.list_whats_new:
            return action.payload;
        case ActionTypes.whats_new.update_whats_new:
            return map(state, dt => {
                if (dt.id === action.payload.id) {
                    return action.payload;
                }
                return dt;
            })
        case ActionTypes.whats_new.delete_whats_new:
            return filter(state,dt=>dt.id!==action.payload)
        default:
            return state;
    }
};